import { render, staticRenderFns } from "./TableSortPage.vue?vue&type=template&id=40a644b6&"
import script from "./TableSortPage.vue?vue&type=script&lang=js&"
export * from "./TableSortPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports